import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Router, ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-login',
  imports: [FormsModule, RouterModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  returnUrl: string = '/';
  loginData = { whatsapp: '', email: '' };
  loading = false;
  message = '';
  messageType: 'success' | 'error' = 'success';

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastService
  ) { }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  async onSubmit() {
    let cleaned = this.loginData.whatsapp.replace(/\D/g, '');  // only digits
    if (cleaned.length < 11 || cleaned.length > 13) {
      this.toast.error('Enter a valid phone number');
      return;
    }

    this.loading = true;
    this.message = '';

    try {
      const res: any = await firstValueFrom(
        this.authService.sendOtp(cleaned, 'whatsapp')
      );
      this.toast.success('OTP sent!')
      this.router.navigate(['/otp'], { state: { whatsapp: cleaned } });

    } catch (err: any) {
      this.toast.error(err?.error?.error || err?.message || 'OTP failed');
    } finally {
      this.loading = false;
    }
  }

  async googleLogin() {
    try {
      const user = await this.authService.loginWithGoogle(this.returnUrl);
      //Login successful → listings page
      this.router.navigate(['/listings']);
      this.toast.success("Logged in: " + user.email);
    } catch (e: any) {
      this.toast.error(e.message);
    }
  }

  async sendMagicLink() {
    try {
      await this.authService.sendMagicLink(this.loginData.email);
      this.toast.success("Magic link sent! Check your email.");
    } catch (e: any) {
      this.toast.error(e.message);
    }
  }
}
